import { createSelector } from 'reselect'
import { ReduxState } from 'store/createRootReducer'

type TotalAddressesSelector = (state: ReduxState) => number
const getTotalAddresses: TotalAddressesSelector = state => state.addresses.pagination.total

export const totalAddressesSelector: TotalAddressesSelector = createSelector(getTotalAddresses, total => total)
